/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSpecialOffer, toggleModalDiscount } from '../../../reduxStore/navigation/actions';
import { setTariff } from '../../../reduxStore/data/actions';
import { getDiscountTariff } from '../../../utils/scripts/parseTariff';
import * as S from './styled';
import { ChartImage } from './components';
import { BrandButton } from '../../everydoggyV2/brandButton/brandButton';
import {
  analyticsEventsTracker,
  GTMOnboardingFunnelEvent,
  EVENT_TRACKERS,
} from '../../../utils/analytics';
import locales from '../../../content.json';
import closeImage from './img/close.png';
import discount from './img/discount.png';
import { RootState } from '../../../store';


interface Props {
	showModalDiscount: boolean;
}

export const PaymentModalDiscount: FC<Props> = props => {
	const { showModalDiscount } = props;
	const dispatch = useDispatch();
	const tariff = useSelector((state: RootState) => state.data.tariff);

	function addEventsShowSpecialOffer() {
		analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.showSpecialOffer(), EVENT_TRACKERS.GTM);
	}

	function switchTariff() {
		dispatch(setTariff(getDiscountTariff(tariff)));
	}

	useEffect(() => {
		document.querySelector('html').classList.add('disableScroll');
		addEventsShowSpecialOffer();
		dispatch(showSpecialOffer());
		switchTariff();
	}, []);

	function addEventsСhooseSpecialOffer () {
    analyticsEventsTracker.trackWithTarget(
      GTMOnboardingFunnelEvent.chooseSpecialOffer(),
      EVENT_TRACKERS.GTM
    );
  };

	function closeHandler() {
		document.querySelector('html').classList.remove('disableScroll');
		dispatch(toggleModalDiscount());
	}

	return (
		<S.PaymentModalDiscount showModalDiscount={showModalDiscount}>
			<S.CloseButtonContainer>
				<S.CloseButton onClick={closeHandler} >
					<img src={closeImage} />
				</S.CloseButton>
			</S.CloseButtonContainer>
			<S.Margined>
				<S.Title>{locales[window.userLang].payment_text_57}</S.Title>
				<S.Wrapper>
					<S.ChartWrapper>
						<S.ChartContainer>
							<ChartImage />
							<S.Bubble2>{locales[window.userLang].payment_text_58}</S.Bubble2>
							<S.Bubble3>{locales[window.userLang].payment_text_59}</S.Bubble3>
						</S.ChartContainer>
					</S.ChartWrapper>
					<S.Description>
						<p>{locales[window.userLang].payment_text_60}</p>
						<p>{locales[window.userLang].payment_text_61}</p>
					</S.Description>
				</S.Wrapper>
			</S.Margined>
			<S.Offer>
				<S.OfferImg src={discount} />
				<h4>{locales[window.userLang].payment_text_62}</h4>
				<S.OfferText dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_63}}>
				</S.OfferText>
				<S.ButtonWrapper>
					<BrandButton
						noShadows={true}
						onClick={() => {
							addEventsСhooseSpecialOffer();
							closeHandler();
						}}
					><p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_64}} /></BrandButton>
				</S.ButtonWrapper>
			</S.Offer>
		</S.PaymentModalDiscount>
	);
};
